import {useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useBeforeFirstRender = (f) => {
  const [hasRendered, setHasRendered] = useState(false)
  useEffect(() => {setHasRendered(true)}, [hasRendered])
  if (!hasRendered) {
    f();
  }
}

export const useDispatchHook = (dispatchAction) => {
  const dispatch = useDispatch();
  useEffect( () => {
    dispatch(dispatchAction)
  }, [dispatch, dispatchAction])
}